<template>
  <div>
    <v-spinner v-if="cargando"></v-spinner>
    <v-layout
      row
      wrap
      v-else
    >
      <v-flex xs12>
        <a
          href="javascript:void(0);"
          @click="cerrar"
        > Volver al listado </a>
      </v-flex>

      <template v-if="itemSeleccionado">
        <v-flex xs12>
          <archivos-detalle-datos-generales
            v-bind:item="itemSeleccionado"
            v-bind:solo-lectura="!puedoEditar()"
          ></archivos-detalle-datos-generales>
        </v-flex>

      </template>

    </v-layout>
  </div>
</template>

<script>
import mixinPaciente from '@/mixins/paciente'
import abmFormularioMixin from '@/mixins/abmFormulario'
import ArchivosDetalleDatosGenerales from './ArchivosDetalleDatosGenerales'
import _ from 'lodash'

export default {
  name: 'PacienteArchivosDetalle',

  props: {
    archivoId: {
      type: Number,
      required: true
    }
  },
  mixins: [abmFormularioMixin, mixinPaciente],
  components: {
    ArchivosDetalleDatosGenerales
  },
  computed: {
    usuario () {
      return this.$store.getters.getUser
    }
  },
  data () {
    return {
      cargando: true,
      itemSeleccionado: null

    }
  },

  methods: {
    cargarInfo () {
      let vm = this
      vm.modeloApi.obtenerArchivo(vm.usuario.persona_id, vm.archivoId).then(data => {
        vm.itemSeleccionado = _.cloneDeep(data)
        vm.cargando = false
      })
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
